/* global DefaultRequestBridge */

import defaultFetch from 'isomorphic-fetch';
import forEach from 'lodash/forEach';

/**
 * @param {object} data
 * @returns {FormData}
 */
export const getFormData = data => {
    const body = new FormData();

    forEach(data, (value, field) => body.append(field, value));

    return body;
};

/**
 * A small wrapper around fetch that should hand over the request
 * to the native app code in case there is no internet connection.
 * @param {String} url
 * @param {Object} [options]
 * @returns {Promise<Response>}
 */
const fetch = (url, options = null) => {
    // MPGES-331: avoid JS bridge fetch as it causes file system access (we want to avoid for all costs due to caching problems)
    // if (window.DefaultRequestBridge) return DefaultRequestBridge.fetch(url, options);

    if (options && options.body !== null && typeof options.body === 'object') {
        return defaultFetch(url, { ...options, body: getFormData(options.body) });
    }

    return defaultFetch(url, options);
};

export default fetch;



// WEBPACK FOOTER //
// ./scripts/utils/fetch.js